import ChatRelease from "./ChatRelease";

export default ChatRelease;
